var React = require('react');

function TwitterhoverInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#1da1f2","key":0}),React.createElement("path",{"d":"M13,23a9.26,9.26,0,0,0,9.3-9.2h0v-.6A9.12,9.12,0,0,0,24,11.5a5.92,5.92,0,0,1-1.9.5,3.1,3.1,0,0,0,1.4-1.8,4.85,4.85,0,0,1-2.1.8,3.2,3.2,0,0,0-4.6-.1,3.1,3.1,0,0,0-1,2.4,2.2,2.2,0,0,0,.1.8,9.56,9.56,0,0,1-6.8-3.4,3.32,3.32,0,0,0,1,4.4,4.19,4.19,0,0,1-1.5-.4h0a3.23,3.23,0,0,0,2.6,3.2,2.77,2.77,0,0,1-.9.1,1.27,1.27,0,0,1-.6-.1,3.34,3.34,0,0,0,3.1,2.3,6.77,6.77,0,0,1-4.1,1.4H7.9A10.3,10.3,0,0,0,13,23","fill":"#fff","key":1})]);
}

TwitterhoverInline.defaultProps = {"id":"Calque_1","data-name":"Calque 1","viewBox":"0 0 32 32"};

module.exports = TwitterhoverInline;

TwitterhoverInline.default = TwitterhoverInline;
